import axios from "axios";
import { Toast } from "vant";
import { getWechatEnv } from "@/utils/utils";

// 默认配置
const service = axios.create({
  baseURL: "/",
  timeout: 10000, // 超时时间
});

// 添加请求拦截器
service.interceptors.request.use(
  (config) => {
    config.headers["platform"] = "h5"; // 平台类型
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    if (userInfo) {
      config.headers["x-token"] = userInfo.token; // token
      config.headers["userId"] =
        getWechatEnv() === 1 ? userInfo.userId : userInfo.openid; // 用户id
      config.headers["userName"] = encodeURIComponent(userInfo.name); // 用户名称
      config.headers["orgList"] = userInfo.department; // 部门
      config.headers["orgId"] = "";
      config.headers["roleIds"] = encodeURIComponent(userInfo.position); // 岗位
      config.headers["roleType"] = "";
      config.headers["tenantId"] = "120000";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 添加响应拦截器
service.interceptors.response.use(
  (res) => {
    if (res.data.code) {
      const code = res.data.code;
      // 获取错误信息
      const { msg } = res.data;
      if (code === 0) {
        return res.data;
      } else if (code === 200001) {
        return res.data;
      } else if (code === 300012) {
        return res.data;
      } else if (code === 50002) {
        return res.data;
      } else {
        Toast(msg);
        return Promise.reject("error");
      }
    } else {
      return res.data;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
